// Lead attribution tracker — stores user's browsing context in localStorage
// so every lead form submission can be stamped with "what did they view?"

const KEY = 'lc_attribution_v1';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
const MAX_HISTORY = 10;

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.updated_at || Date.now() - new Date(data.updated_at).getTime() > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch (e) {
    if (process.env.NODE_ENV === 'development') console.error('[attribution] read failed:', e);
    return null;
  }
};

const write = (data) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...data, updated_at: new Date().toISOString() }));
  } catch (e) {
    if (process.env.NODE_ENV === 'development') console.error('[attribution] write failed (storage full / blocked):', e);
  }
};

export const setModelViewed = (modelId, modelName) => {
  if (!modelId) return;
  const current = read() || { models_viewed: [], first_seen_at: new Date().toISOString() };
  const history = (current.models_viewed || []).filter(m => m.id !== modelId);
  history.unshift({ id: modelId, name: modelName || modelId, at: new Date().toISOString() });
  write({
    ...current,
    last_model_id: modelId,
    last_model_name: modelName || modelId,
    last_model_viewed_at: new Date().toISOString(),
    models_viewed: history.slice(0, MAX_HISTORY),
  });
};

export const setPhotoClicked = (modelId, modelName, photoUrl, photoIndex) => {
  if (!photoUrl) return;
  const current = read() || { models_viewed: [], first_seen_at: new Date().toISOString() };
  write({
    ...current,
    last_photo_url: photoUrl,
    last_photo_model_id: modelId || current.last_model_id || null,
    last_photo_model_name: modelName || current.last_model_name || null,
    last_photo_index: typeof photoIndex === 'number' ? photoIndex : null,
    last_photo_clicked_at: new Date().toISOString(),
  });
};

export const getAttribution = () => {
  const data = read();
  if (!data) return null;
  // Return a compact object — skip undefined fields
  const out = {};
  [
    'last_model_id', 'last_model_name', 'last_model_viewed_at',
    'last_photo_url', 'last_photo_model_id', 'last_photo_model_name',
    'last_photo_index', 'last_photo_clicked_at',
    'first_seen_at',
  ].forEach(k => { if (data[k] != null) out[k] = data[k]; });
  if (Array.isArray(data.models_viewed) && data.models_viewed.length) {
    out.models_viewed = data.models_viewed;
  }
  out.landing_page = data.landing_page || null;
  out.referrer = data.referrer || null;
  return Object.keys(out).length ? out : null;
};

export const initAttribution = () => {
  const current = read();
  if (!current) {
    write({
      first_seen_at: new Date().toISOString(),
      landing_page: window.location.pathname + window.location.search,
      referrer: document.referrer || null,
      models_viewed: [],
    });
  }
};

export const clearAttribution = () => {
  try { localStorage.removeItem(KEY); } catch (e) {
    if (process.env.NODE_ENV === 'development') console.error('[attribution] clear failed:', e);
  }
};
